const INFO_TEXT =
  'Проверить состояние счета сертификата, записаться на программы и профподготовку, оставить отзывы Вы можете в Центре опережающей профессиональной подготовкий: ';
const SLOGAN_TEXT =
  'Давайте вместе помогать нашим детям в сложном выборе правильного жизненного пути!';

export { INFO_TEXT, SLOGAN_TEXT };



// WEBPACK FOOTER //
// ./src/tools/generatepdf/text.ts